"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.1.2'] && _();
}
catch (e) { }
